import { Component } from '@angular/core';
import { LocalStorageService } from '@shared/services/local-storage.service';

@Component({
  selector: 'rav-help-roles',
  templateUrl: './help-roles.component.html',
  styleUrls: ['./help-roles.component.scss']
})
export class HelpRolesComponent {
  constructor(private localStorage: LocalStorageService) {}

  /**
   * Determines if the user is an admin role
   */
  isUserAdminRole(): boolean {
    const role = this.localStorage.userWithToken ? this.localStorage.userWithToken.role : '';

    switch (role) {
      case 'superadmin':
      case 'admin':
        return true;
      default:
        return false;
    }
  }
}
